// Fire-and-forget event tracker. Safe to call from any client component.
export function trackEvent(eventType, metadata = {}, userTier = null) {
  if (typeof window === 'undefined') return
  try {
    fetch('/api/track-event', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        eventType,
        userTier,
        sourcePage: window.location.pathname,
        metadata,
      }),
      keepalive: true,
    }).catch(() => {})
  } catch {}
}
